/**
 * RosterToolbar — search and status pills for a project's roster (demo /manage-team and /tables/data-tables header).
 */
import React from 'react';
import { FilterPills, SearchBar, Toolbar } from '../../../components/ui/index.js';

export type RosterFilter = 'all' | 'attn' | 'working' | 'available' | 'blocked' | 'paused';

interface RosterToolbarProps {
  filter: RosterFilter;
  setFilter: (next: RosterFilter) => void;
  counts: Record<RosterFilter, number>;
  searchQuery: string;
  setSearchQuery: (q: string) => void;
  /** Scope and layout switches. */
  right?: React.ReactNode;
}

const FILTERS: Array<{ key: RosterFilter; label: string }> = [
  { key: 'all', label: 'All' },
  { key: 'attn', label: 'Needs attention' },
  { key: 'working', label: 'Working' },
  { key: 'available', label: 'Available' },
  { key: 'blocked', label: 'Blocked' },
  { key: 'paused', label: 'Paused' },
];

export const RosterToolbar: React.FC<RosterToolbarProps> = ({
  filter,
  setFilter,
  counts,
  searchQuery,
  setSearchQuery,
  right,
}) => (
  <Toolbar
    search={
      <SearchBar value={searchQuery} onChange={setSearchQuery} placeholder="Search employees, roles, projects…" />
    }
    pills={
      <FilterPills
        aria-label="Status"
        options={FILTERS.map((f) => ({ id: f.key, label: f.label, count: counts[f.key] }))}
        value={filter}
        onChange={(id) => setFilter(id as RosterFilter)}
      />
    }
    right={right}
  />
);
